let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("3XMOA"), load("2uoBF"), load("c6MKV"), load("aZinD"), load("cyGuT"), load("aOJkF")]).then(() => parcelRequire('fOc3P'));